import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastProvider } from 'react-toast-notifications';
import * as Sentry from '@sentry/react';

import App from './components/app';

import store from './store/store';
import * as serviceWorker from './serviceWorker';

import './styles/index.scss';
import AuthController from './controllers/AuthController';

if (!window.origin.includes('localhost')) {
  Sentry.init({ dsn: 'https://9231bc023148423591b90264b541c4d2@o432220.ingest.sentry.io/5384587' });
}

if (!window.origin.includes('alpha.blueraster.io')) {
  AuthController.login();
}

ReactDOM.render(
  <Provider store={store}>
    <ToastProvider autoDismiss={true} autoDismissTimeout={6000} placement='bottom-center'>
      <App />
    </ToastProvider>
  </Provider>,
  document.getElementById('app-container')
);

serviceWorker.unregister();
